import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  Card,
  CardContent,
  Hidden,
  Button,
  InputAdornment,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import TuneIcon from '@material-ui/icons/Tune';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import ServiceInputCalculatorModal from '../Common/ServiceInputCalculatorModal';
import useApi from '../../../utils/useApi';
import UIContainer from '../../UI/Container/UIContainer';
import UIFormTitle from '../../UI/Form/Title/UIFormTitle';
import validationSchema from './validationSchema';
import {
  capitalize,
  clearObject,
  isEqualObject,
  formattedCurrency,
  calculateMarkupByValue,
  calculateMarginByValue,
  parseFractionOrNumber,
} from '../../../utils/utils';
import UIFormContainerSave from '../../UI/Form/ContainerSave/UIFormContainer';
import UIModalOldForm from '../../UI/ModalOldForm/UIModalOldForm';
import useStorage from '../../../utils/useStorage';
import SupplierCreateModal from '../../Supplier/SupplierCreateModal';
import UIImageUpload from '../../UI/ImageUpload/UIImageUpload';
import UIDuxiaDescriptionButton from '../../UI/Duxia/UIDuxiaDescriptionButton';

const initialState = {
  name: '',
  description: '',
  category: null,
  supplier: null,
  value: 0,
  particulars: null,
  generateCost: false,
  inputs: [],
  show_in_catalog: true,
  images: [],
};

const supplierFilter = createFilterOptions();

const ServiceNew = () => {
  const [oldValues, setOldValues] = useStorage('formService');
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(true);
  const [createCostChecked, setCreateCostChecked] = useState(false);
  const [options, setOptions] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const [modalSupplier, setModalSupplier] = useState(false);
  const [newSupplierName, setNewSupplierName] = useState('');

  const [registerLoad, registerInfo, setRegisterInfo] = useApi({
    method: 'post',
    url: '/services',
  });

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const createCostHandle = (event) => {
    setCreateCostChecked(event.target.checked);
  }

  const [categoryLoad, categoryInfo] = useApi({
    method: 'get',
    url: '/services/categories',
    params: { type: 'S' },
  });

  const [suppliersLoad, suppliersInfo] = useApi({
    method: 'get',
    url: '/suppliers',
  });

  const [productsLoad, productsInfo] = useApi({
    method: 'get',
    url: '/products',
    params: { lacking: 0 },
  });

  const [servicesLoad, servicesInfo] = useApi({
    method: 'get',
    url: '/services',
    params: { isActive: '1' },
  });

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [inputAmount, setInputAmount] = useState(1);
  const [calculatorOpen, setCalculatorOpen] = useState(false);
  const [calculatorItem, setCalculatorItem] = useState(null);
  const [editingInputIndex, setEditingInputIndex] = useState(null);

  const inputOptions = [
    ...(productsInfo.data || []).map(p => ({ ...p, inputType: 'P' })),
    ...(servicesInfo.data || []).map(s => ({ ...s, inputType: 'S' }))
  ];

  const [editingIndex, setEditingIndex] = useState(null);
  const [editingAmount, setEditingAmount] = useState(0);

  const getInputCost = (input) => {
    if (input.cost !== undefined && input.cost !== null) return parseFloat(input.cost);
    const option = inputOptions.find(i => (input.productId && i.inputType === 'P' && i.id === input.productId) || (input.inputServiceId && i.inputType === 'S' && i.id === input.inputServiceId));
    return parseFloat(option?.cost || 0);
  };

  const getInputValue = (input) => {
    if (input.value !== undefined && input.value !== null) return parseFloat(input.value);
    const option = inputOptions.find(i => (input.productId && i.inputType === 'P' && i.id === input.productId) || (input.inputServiceId && i.inputType === 'S' && i.id === input.inputServiceId));
    return parseFloat(option?.value || 0);
  };

  const getInputName = (input) => {
    if (input.name) return input.name;
    const option = inputOptions.find(i => (input.productId && i.inputType === 'P' && i.id === input.productId) || (input.inputServiceId && i.inputType === 'S' && i.id === input.inputServiceId));
    return option?.name || 'Item desconhecido';
  };

  const getInputType = (input) => {
    if (input.inputType) return input.inputType;
    if (input.inputServiceId) return 'S';
    return 'P';
  };

  const calculateTotalCost = (inputs) => {
    if (!inputs) return 0;
    return inputs.reduce((acc, curr) => acc + (getInputCost(curr) * parseFloat(curr.amount)), 0);
  };

  const calculateTotalPotentialGain = (inputs) => {
    if (!inputs) return 0;
    return inputs.reduce((acc, curr) => acc + (getInputValue(curr) * parseFloat(curr.amount)), 0);
  };

  function changeModal() {
    setOpen(!open);
  }

  function setFormValues() {
    setOldValues(null);
    setOptions(null);
    changeModal();
  }

  function updateStorage(values) {
    setOldValues(values);
  }

  useEffect(() => {
    categoryLoad();
    suppliersLoad();
    productsLoad();
    servicesLoad();
    if (oldValues && !isEqualObject(oldValues, initialState)) {
      changeModal();
    }
  }, []);

  function onSubmit(values, { resetForm }) {
    setIsSaving(true);
    const valuesProduct = {
      ...values,
      category: values.category.id,
      supplier: values.supplier.id,
      show_in_catalog: Boolean(values.show_in_catalog),
      images: values.images || [],
      inputs: values.inputs.map((i) => {
        const item = { amount: i.amount };
        if (i.productId) item.productId = i.productId;
        if (i.inputServiceId) item.inputServiceId = i.inputServiceId;
        return item;
      }),
    };
    registerLoad({
      data: valuesProduct,
      onCompleted: (response) => {
        if (response) {
          resetForm({ values: initialState });
          setOldValues(null);
          setOptions(null);
          setSelectedProduct(null);
          setInputAmount(0);
        }
        setIsSaving(false);
      },
      onError: () => {
        setIsSaving(false);
      },
    });
  }

  function setSelectedProductChange(newValue) {
    setSelectedProduct(newValue);
    if (newValue) {
      setInputAmount(1);
    }
  }

  const handleAddInput = (values, setFieldValue, amountToUse) => {
    const rawAmount = amountToUse !== undefined ? amountToUse : inputAmount;
    const parsedAmount = parseFractionOrNumber(rawAmount);
    if (selectedProduct && parsedAmount > 0) {
      const newInputs = [
        ...values.inputs,
        {
          productId: selectedProduct.inputType === 'P' ? selectedProduct.id : null,
          inputServiceId: selectedProduct.inputType === 'S' ? selectedProduct.id : null,
          name: selectedProduct.name,
          cost: parseFloat(selectedProduct.cost || 0),
          value: parseFloat(selectedProduct.value || 0),
          amount: parsedAmount,
          inputType: selectedProduct.inputType
        }
      ];
      setFieldValue('inputs', newInputs);
      setSelectedProduct(null);
      setInputAmount(1);
    }
  };

  const handleOpenEditInputModal = (index, input) => {
    const option = inputOptions.find(i => 
      (input.productId && i.inputType === 'P' && i.id === input.productId) || 
      (input.inputServiceId && i.inputType === 'S' && i.id === input.inputServiceId)
    );
    setEditingInputIndex(index);
    setCalculatorItem(option || {
      name: input.name,
      cost: input.cost,
      value: input.value,
      unit: input.unit || '',
      amount: input.amount,
      inputType: input.inputType,
    });
    setCalculatorOpen(true);
  };

  const handleOpenAddCalculator = () => {
    setEditingInputIndex(null);
    setCalculatorItem(selectedProduct);
    setCalculatorOpen(true);
  };

  const handleApplyCalculator = (calculatedValue, values, setFieldValue) => {
    const parsedAmount = parseFractionOrNumber(calculatedValue);
    if (parsedAmount <= 0) return;

    if (editingInputIndex !== null && editingInputIndex !== undefined) {
      const newInputs = values.inputs.map((item, i) =>
        i === editingInputIndex ? { ...item, amount: parsedAmount } : item
      );
      setFieldValue('inputs', newInputs);
      setEditingInputIndex(null);
      setCalculatorItem(null);
    } else {
      handleAddInput(values, setFieldValue, calculatedValue);
    }
  };

  function handleRemoveInput(index, values, setFieldValue) {
    const newInputs = values.inputs.filter((_, i) => i !== index);
    setFieldValue('inputs', newInputs);
  }

  return (
    <>
      <Formik
        initialValues={oldValues || initialState}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ setFieldValue, errors, touched, values }) => (
          <Form onBlur={() => updateStorage(values)}>
            <UIContainer container direction="row">
              <Grid
                item
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                xs={12}
              >
                <UIFormTitle id="tour-service-title" title="Novo serviço" />
              </Grid>
              <Grid item xs={12}>
                <Box id="tour-service-metrics" mb={2} p={2} bgcolor="grey.100" borderRadius={8}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="caption" color="textSecondary">Custo Estimado</Typography>
                      <Typography variant="h6">{formattedCurrency(calculateTotalCost(values.inputs))}</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="caption" color="textSecondary">Markup</Typography>
                      <Typography variant="h6">{calculateMarkupByValue(calculateTotalCost(values.inputs), values.value)}%</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="caption" color="textSecondary">Margem</Typography>
                      <Typography variant="h6" style={{ color: parseFloat(calculateMarginByValue(calculateTotalCost(values.inputs), values.value)) > 20 ? 'green' : 'orange' }}>
                        {calculateMarginByValue(calculateTotalCost(values.inputs), values.value)}%
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  id="tour-service-name"
                  name="name"
                  label="Nome"
                  error={Boolean(errors.name)}
                  helperText={touched.name && errors.name}
                  placeholder="Informe o nome do serviço"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  disableClearable
                  noOptionsText="Sem opções"
                  value={values.category}
                  disabled={categoryInfo.loading}
                  options={categoryInfo.data !== null ? categoryInfo.data : []}
                  getOptionLabel={(category) => category.name}
                  getOptionSelected={(option, value) => option.id === value.id}
                  onChange={(event, category) => {
                    if (event.target.value !== '' || category) {
                      setFieldValue('category', category);
                      setFieldValue(
                        'particulars',
                        clearObject(category.particulars, true),
                      );
                      setOptions({
                        ...category.particulars,
                      });
                    } else {
                      setFieldValue('category', null);
                      setFieldValue('particulars', null);
                      setOptions(null);
                    }
                  }}
                  defaultValue={
                    oldValues !== null && oldValues.category
                      ? oldValues.category
                      : null
                  }
                  renderInput={(params) => (
                    <Field
                      {...params}
                      label="Categoria"
                      name="category"
                      error={Boolean(errors.category)}
                      helperText={touched.category && errors.category}
                      variant="standard"
                      placeholder="Informe a categoria do serviço"
                      component={TextField}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                  <Typography variant="body2" style={{ fontWeight: 600, color: '#333' }}>
                    Descrição para o Catálogo Virtual
                  </Typography>
                  <UIDuxiaDescriptionButton
                    itemName={values.name}
                    categoryName={values.category ? values.category.name : ''}
                    itemType="serviço"
                    currentDescription={values.description}
                    onGenerated={(newDesc) => setFieldValue('description', newDesc)}
                  />
                </Box>
                <Field
                  name="description"
                  placeholder="Descrição detalhada do serviço que será exibida para os clientes no catálogo..."
                  multiline
                  rows={3}
                  variant="outlined"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  disableClearable
                  noOptionsText="Sem opções"
                  value={values.supplier}
                  disabled={suppliersInfo.loading}
                  options={
                    suppliersInfo.data !== null ? suppliersInfo.data : []
                  }
                  getOptionLabel={(option) => {
                    if (typeof option === 'string') {
                      return option;
                    }
                    if (option.inputValue) {
                      return option.name;
                    }
                    return option.name;
                  }}
                  getOptionSelected={(option, value) => option.id === value.id}
                  filterOptions={(options, params) => {
                    const filtered = supplierFilter(options, params);
                    const existing = options.some(
                      (option) =>
                        option.name.toLowerCase() ===
                        params.inputValue.toLowerCase(),
                    );
                    if (params.inputValue !== '' && !existing) {
                      filtered.push({
                        inputValue: params.inputValue,
                        name: `Adicionar "${params.inputValue}"`,
                      });
                    }
                    return filtered;
                  }}
                  onChange={(event, newValue) => {
                    if (!newValue) {
                      setFieldValue('supplier', null);
                      return;
                    }
                    if (newValue.inputValue) {
                      setNewSupplierName(newValue.inputValue);
                      setModalSupplier(true);
                    } else {
                      setFieldValue('supplier', newValue);
                    }
                  }}
                  defaultValue={
                    oldValues !== null && oldValues.supplier
                      ? oldValues.supplier
                      : null
                  }
                  renderInput={(params) => (
                    <Field
                      {...params}
                      label="Fornecedor"
                      name="supplier"
                      error={Boolean(errors.supplier)}
                      helperText={touched.supplier && errors.supplier}
                      variant="standard"
                      placeholder="Informe o fornecedor do serviço"
                      component={TextField}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CurrencyTextField
                  id="tour-service-value"
                  type="tel"
                  value={values.value}
                  label="Valor de venda"
                  variant="standard"
                  decimalCharacter=","
                  error={Boolean(errors.value)}
                  helperText={errors.value}
                  digitGroupSeparator="."
                  currencySymbol="R$"
                  outputFormat="string"
                  onChange={(ev, value) => setFieldValue('value', value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onClick={handleChange}
                      onChange={() => setFieldValue('barCode', '')}
                    />
                  }
                  label="Código de serviço"
                />
                <Field
                  disabled={checked}
                  f
                  name="barCode"
                  label={
                    checked ? 'Gerado automaticamente' : 'Código de serviço'
                  }
                  placeholder="Informe o código utilizado para identificar o serviço"
                  style={{ width: '70%' }}
                  as={TextField}
                />
                <FormControlLabel
                  id="tour-service-cost-check"
                  control={
                    <Checkbox
                      checked={createCostChecked}
                      onClick={createCostHandle}
                      onChange={() => setFieldValue('generateCost', !createCostChecked)}
                    />
                  }
                  label="Repasse (serviço prestado por terceiro)"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(values.show_in_catalog)}
                      onChange={(e) => setFieldValue('show_in_catalog', e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Exibir no Catálogo Virtual"
                />
              </Grid>
              <Grid item xs={12}>
                <UIImageUpload
                  images={values.images || []}
                  onChange={(newImages) => setFieldValue('images', newImages)}
                  label="Imagens do Serviço"
                  itemName={values.name}
                />
              </Grid>
            </UIContainer>

            <UIContainer container direction="row">
              <Grid item xs={12}>
                <UIFormTitle title="Caracteristicas" />
              </Grid>
              {values.particulars && options !== null ? (
                Object.entries(options).map(([key, value]) => (
                  <Grid item xs={12} md={3}>
                    <InputLabel shrink id={key}>
                      {capitalize(key)}
                    </InputLabel>
                    <Field
                      name={`particulars.${key}`}
                      disabled={!values.category}
                      error={Boolean(errors.particulars)}
                      helperText={touched.particulars && errors.particulars}
                      labelId={key}
                      displayEmpty
                      fullWidth
                      as={Select}
                    >
                      <MenuItem disabled value="">
                        <em>Informe o(a) {key}</em>
                      </MenuItem>
                      {typeof value === 'object'
                        ? value.map((vl) => (
                          <MenuItem key={vl} value={vl}>
                            {vl}
                          </MenuItem>
                        ))
                        : value && (
                          <MenuItem key={value} value={value}>
                            {value}
                          </MenuItem>
                        )}
                    </Field>
                  </Grid>
                ))
              ) : (
                <Typography noWrap variant="inherit">
                  Selecione uma categoria
                </Typography>
              )}
            </UIContainer>

            <UIContainer container direction="row">
              <Grid item xs={12}>
                <UIFormTitle id="tour-service-composition" title="Insumos Vinculados" />
              </Grid>
              <Grid item xs={12} sm={6} md={5}>
                <Autocomplete
                  id="tour-service-input-search"
                  options={inputOptions}
                  getOptionLabel={(option) => {
                    if (option.inputType === 'P') {
                      return `${option.name} (Produto - ${formattedCurrency(option.cost)})`;
                    }
                    const cost = parseFloat(option.cost || 0);
                    if (cost > 0) {
                      return `${option.name} (Serviço - ${formattedCurrency(cost)})`;
                    }
                    return `${option.name} (Serviço - Sem custo - Indisponível)`;
                  }}
                  getOptionDisabled={(option) => option.inputType === 'S' && parseFloat(option.cost || 0) <= 0}
                  groupBy={(option) => (option.inputType === 'P' ? 'Produtos' : 'Serviços')}
                  value={selectedProduct}
                  onChange={(event, newValue) => setSelectedProduct(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Buscar produto ou serviço insumo"
                      helperText="Apenas serviços ativos com custo cadastrado (> R$ 0,00) são elegíveis como insumo."
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={7} sm={3} md={4}>
                <TextField
                  id="tour-service-input-amount"
                  label="Quantidade por serviço"
                  placeholder="Ex: 1 ou 1/24"
                  value={inputAmount}
                  onChange={(ev) => setInputAmount(ev.target.value)}
                  helperText={
                    typeof inputAmount === 'string' && inputAmount.includes('/')
                      ? `≈ ${parseFractionOrNumber(inputAmount)} un`
                      : 'Suporta fração (ex: 1/24)'
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Calcular porção / medida">
                          <span>
                            <IconButton
                              size="small"
                              onClick={handleOpenAddCalculator}
                              disabled={!selectedProduct}
                              edge="end"
                            >
                              <TuneIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={5} sm={3} md={3} style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => handleAddInput(values, setFieldValue)}
                  disabled={!selectedProduct || parseFractionOrNumber(inputAmount) <= 0}
                  startIcon={<AddIcon />}
                  style={{ height: 40, fontWeight: 600 }}
                >
                  Adicionar
                </Button>
              </Grid>
              <ServiceInputCalculatorModal
                open={calculatorOpen}
                onClose={() => {
                  setCalculatorOpen(false);
                  setEditingInputIndex(null);
                  setCalculatorItem(null);
                }}
                item={calculatorItem || selectedProduct}
                initialAmount={editingInputIndex !== null && values.inputs[editingInputIndex] ? values.inputs[editingInputIndex].amount : inputAmount}
                isEditing={editingInputIndex !== null}
                onApply={(calculatedValue) => handleApplyCalculator(calculatedValue, values, setFieldValue)}
              />
              {values.inputs.length > 0 && (
                <Grid item xs={12}>
                  {/* Desktop Table View */}
                  <Hidden smDown>
                    <TableContainer component={Paper} variant="outlined" style={{ marginTop: 8 }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow style={{ backgroundColor: '#fafafa' }}>
                            <TableCell style={{ fontWeight: 600 }}>Insumo</TableCell>
                            <TableCell style={{ fontWeight: 600 }} align="center">Tipo</TableCell>
                            <TableCell style={{ fontWeight: 600 }} align="center">Qtd</TableCell>
                            <TableCell style={{ fontWeight: 600 }} align="right">Custo Unit.</TableCell>
                            <TableCell style={{ fontWeight: 600 }} align="right">Venda Unit.</TableCell>
                            <TableCell style={{ fontWeight: 600 }} align="right">Subtotal Custo</TableCell>
                            <TableCell style={{ fontWeight: 600 }} align="center">Ações</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {values.inputs.map((input, index) => {
                            const unitCost = getInputCost(input);
                            const unitValue = getInputValue(input);
                            const type = getInputType(input);
                            return (
                              <TableRow key={index} hover>
                                <TableCell>{getInputName(input)}</TableCell>
                                <TableCell align="center">
                                  <Chip
                                    size="small"
                                    label={type === 'P' ? 'Produto' : 'Serviço'}
                                    style={{
                                      backgroundColor: type === 'P' ? '#e3f2fd' : '#f3e5f5',
                                      color: type === 'P' ? '#1565c0' : '#7b1fa2',
                                      fontWeight: 500,
                                    }}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <span>{parseFloat(input.amount)}</span>
                                </TableCell>
                                <TableCell align="right">{formattedCurrency(unitCost)}</TableCell>
                                <TableCell align="right" style={{ color: '#666' }}>{formattedCurrency(unitValue)}</TableCell>
                                <TableCell align="right" style={{ fontWeight: 500 }}>{formattedCurrency(unitCost * parseFloat(input.amount))}</TableCell>
                                <TableCell align="center">
                                  <Tooltip title="Editar quantidade">
                                    <IconButton size="small" onClick={() => handleOpenEditInputModal(index, input)}>
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Remover insumo">
                                    <IconButton size="small" onClick={() => handleRemoveInput(index, values, setFieldValue)}>
                                      <DeleteIcon fontSize="small" color="error" />
                                    </IconButton>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                          <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell colSpan={5} align="right" style={{ fontWeight: 600 }}>Total de Insumos (Custo)</TableCell>
                            <TableCell align="right" style={{ fontWeight: 700 }}>{formattedCurrency(calculateTotalCost(values.inputs))}</TableCell>
                            <TableCell />
                          </TableRow>
                          <TableRow style={{ backgroundColor: '#fafafa' }}>
                            <TableCell colSpan={5} align="right" style={{ color: '#757575', fontSize: '0.85rem' }}>
                              Ganho Potencial (Soma Venda)
                            </TableCell>
                            <TableCell align="right" style={{ color: '#757575', fontSize: '0.85rem', fontWeight: 500 }}>
                              {formattedCurrency(calculateTotalPotentialGain(values.inputs))}
                            </TableCell>
                            <TableCell />
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Hidden>

                  {/* Mobile Cards View */}
                  <Hidden mdUp>
                    <Box style={{ width: '100%', marginTop: 8 }}>
                      {values.inputs.map((input, index) => {
                        const unitCost = getInputCost(input);
                        const unitValue = getInputValue(input);
                        const type = getInputType(input);
                        return (
                          <Card
                            key={index}
                            variant="outlined"
                            style={{
                              marginBottom: 8,
                              borderLeft: `4px solid ${type === 'P' ? '#1565c0' : '#7b1fa2'}`,
                              borderRadius: 8,
                              backgroundColor: '#FFFFFF',
                            }}
                          >
                            <CardContent style={{ padding: 12, paddingBottom: 12 }}>
                              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                                  {getInputName(input)}
                                </Typography>
                                <Box display="flex" alignItems="center">
                                  <Chip
                                    size="small"
                                    label={type === 'P' ? 'Produto' : 'Serviço'}
                                    style={{
                                      backgroundColor: type === 'P' ? '#e3f2fd' : '#f3e5f5',
                                      color: type === 'P' ? '#1565c0' : '#7b1fa2',
                                      fontWeight: 500,
                                      marginRight: 4,
                                    }}
                                  />
                                  <IconButton size="small" onClick={() => handleRemoveInput(index, values, setFieldValue)}>
                                    <DeleteIcon fontSize="small" color="error" />
                                  </IconButton>
                                </Box>
                              </Box>
                              <Grid container spacing={1} alignItems="center">
                                <Grid item xs={4}>
                                  <Typography variant="caption" color="textSecondary" display="block">
                                    Qtd
                                  </Typography>
                                  <Box display="flex" alignItems="center">
                                    <Typography variant="body2" style={{ fontWeight: 500, marginRight: 4 }}>
                                      {parseFloat(input.amount)}
                                    </Typography>
                                    <IconButton size="small" onClick={() => handleOpenEditInputModal(index, input)}>
                                      <EditIcon style={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Box>
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography variant="caption" color="textSecondary" display="block">
                                    Custo Unit.
                                  </Typography>
                                  <Typography variant="body2">
                                    {formattedCurrency(unitCost)}
                                  </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography variant="caption" color="textSecondary" display="block">
                                    Venda Unit.
                                  </Typography>
                                  <Typography variant="body2" style={{ color: '#666' }}>
                                    {formattedCurrency(unitValue)}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Box display="flex" justifyContent="space-between" mt={1} pt={1} borderTop="1px dashed #eee">
                                <Typography variant="caption" style={{ fontWeight: 600 }}>
                                  Subtotal Custo:
                                </Typography>
                                <Typography variant="caption" style={{ fontWeight: 700 }}>
                                  {formattedCurrency(unitCost * parseFloat(input.amount))}
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        );
                      })}
                      <Paper variant="outlined" style={{ padding: 12, backgroundColor: '#f9f9f9', borderRadius: 8, marginTop: 8 }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                          <Typography variant="body2" style={{ fontWeight: 600 }}>
                            Total de Insumos (Custo):
                          </Typography>
                          <Typography variant="body1" style={{ fontWeight: 700 }}>
                            {formattedCurrency(calculateTotalCost(values.inputs))}
                          </Typography>
                        </Box>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mt={0.5}>
                          <Typography variant="caption" color="textSecondary">
                            Ganho Potencial (Soma Venda):
                          </Typography>
                          <Typography variant="caption" color="textSecondary" style={{ fontWeight: 500 }}>
                            {formattedCurrency(calculateTotalPotentialGain(values.inputs))}
                          </Typography>
                        </Box>
                      </Paper>
                    </Box>
                  </Hidden>
                </Grid>
              )}
              {values.inputs.length === 0 && (
                <Grid item xs={12}>
                  <Box p={3} textAlign="center" bgcolor="grey.50" borderRadius={8} border="1px dashed #ccc" mt={1}>
                    <Typography variant="body2" color="textSecondary">Nenhum insumo vinculado. Use o campo acima para adicionar produtos ou serviços.</Typography>
                  </Box>
                </Grid>
              )}
            </UIContainer>

            <UIFormContainerSave
              id="tour-service-save-btn"
              container
              justify="center"
              direction="row"
              messageSucess={registerInfo.data && registerInfo.data.message}
              messageError="Alguma coisa está errada, verifique os campos"
              error={registerInfo.error}
              loading={isSaving || registerInfo.loading}
              data={registerInfo.data}
              setrequestinfo={setRegisterInfo}
              setFormValues={() => setOldValues(null)}
            />

            <UIModalOldForm
              open={open}
              changeModal={changeModal}
              setFormValues={setFormValues}
            />

            <SupplierCreateModal
              open={modalSupplier}
              initialName={newSupplierName}
              onClose={() => setModalSupplier(false)}
              onSuccess={(newSupplier) => {
                suppliersLoad();
                setFieldValue('supplier', newSupplier);
                setModalSupplier(false);
              }}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ServiceNew;